import { TFunction } from 'i18next';

import { isPromoAvailableDate } from './dateTime';

export interface Prize {
  type: PrizeType;
  nameShort?: string;
  name?: string;
  code?: string;
  description?: string;
  termsAndConditions?: ({ t }: { t: TFunction }) => JSX.Element;
  isMystery?: boolean;
  isWinning?: boolean;
  isX2?: boolean;
}

export enum WheelStatus {
  Locked = 'Locked',
  Waiting = 'Waiting',
  Success = 'Success',
  Failed = 'Failed',
}

export enum PrizeType {
  NDFS,
  NDMS,
  DepMatch,
  DepFS,
  NDC,
  Empty,
}

export const getWidthPrizeInPercent = (total: number) =>
  2 * 50 * Math.sin((Math.PI * (360 / total)) / 180 / 2) + 1;

export const getDegreeOfRotation = (total: number, index?: number) => {
  if (index == null) return 360 / total;
  return (360 / total) * index;
};

export const getOffsetClipPath = (total: number) =>
  Math.ceil(
    (((getWidthPrizeInPercent(total) * 50) /
      Math.floor(
        Math.sqrt(
          Math.pow(50, 2) - Math.pow(getWidthPrizeInPercent(total) / 2, 2)
        )
      ) /
      getWidthPrizeInPercent(total) -
      1.04) *
      100) /
      2
  );

const WHEEL_PROMO_DATE_START = '2024-09-05 00:00:00';
const WHEEL_PROMO_DATE_END = '2024-11-01 23:59:59';

export const isWheelPromoAvailableDate = isPromoAvailableDate(
  WHEEL_PROMO_DATE_START,
  WHEEL_PROMO_DATE_END
);
